<template>
  <div :id="data.id" class="bg-[#080C25] py-6 sm:pb-3 pl-4 sm:px-8 sm:rounded-lg">
    <div class="flex flex-nowrap items-center mb-7 sm:mb-0">
      <OLink class="flex items-center mr-2 sm:mr-0" href="/yasam/astroloji">
        <OIcon icon="homepage/horoscope/astrology" svg-class="w-6 h-6 sm:w-8 sm:h-8" />
        <span class="text-[#3071E7] text-xl sm:text-22 leading-18 font-medium sm:mx-2">Astroloji</span>
      </OLink>
      <div class="border-b border-white-20 w-full mr-4 sm:mr-1 ml-6 sm:ml-4"></div>
    </div>
    <div>
      <Swiper :settings="settings" @swiper="onSwiper">
        <SwiperSlide v-for="item in horoscopes" :key="item.name">
          <OLink :href="item.route" class="horoscope-wrapper flex flex-col items-center my-3 sm:mt-6">
            <div class="rounded-full bg-[#161E35] p-5 mb-4">
              <OIcon :icon="`homepage/horoscope/${item.icons.iconCode}`" width="24" height="24" />
            </div>
            <span class="text-[#D0D9FF] text-base leading-18 tracking-tight font-medium">{{ item.name }}</span>
          </OLink>
        </SwiperSlide>
      </Swiper>
    </div>
  </div>
</template>
<script>
import { computed, defineComponent, ref } from '@nuxtjs/composition-api';
import Swiper from '@/modules/sliders/core/Swiper';
import SwiperSlide from '@/modules/sliders/core/SwiperSlide';
import { useDevice } from '~/composables/useDevice';
import { OLink, OIcon } from '~/modules/common/components/ui';
import { onedioEvents } from '~/modules/tracking/scripts/onedioEvents';

export default defineComponent({
  components: {
    Swiper,
    SwiperSlide,
    OLink,
    OIcon,
  },
  props: {
    data: {
      type: Object,
      default: {},
      required: true,
    },
  },
  setup(props) {
    const { sendHomepageEvent } = onedioEvents();
    const swiperRef = ref(null);
    const { isMobile } = useDevice();
    const horoscopes = computed(() => props.data.data);
    const settings = computed(() => ({
      slidesPerView: isMobile.value ? 4.5 : horoscopes.value.length,
      breakpoints: {
        320: { spaceBetween: 16 },
        640: { spaceBetween: 24 },
      },
    }));

    const onSwiper = (swiper) => {
      swiperRef.value = swiper;
      swiper.on('click', function () {
        const slideIndex = parseInt(swiper.clickedIndex);
        sendHomepageEvent('Astroloji', 'click', horoscopes.value[slideIndex].name);
      });
    };

    return { horoscopes, settings, isMobile, onSwiper };
  },
});
</script>
<style scoped lang="scss">
.horoscope-wrapper {
  &:hover {
    transform: scale(1.1);
    transition: all 0.2s 0s ease-in;
  }
}
</style>
